import {
  defaultGuid, useIsMsalAuth, useIsUserAuth, useStickySafeNavigate,
} from '@equifinance/shared';
import { useEffect, useMemo } from 'react';
import { useAccountContext } from '../contexts';
import { ApplicationPageType } from '../components/AccountTabNav';
import { Stages } from '../types/Stages';

export default function usePageAccessControl(currentPage: ApplicationPageType) {
  const isInternalUser = useIsMsalAuth();
  const isExternalUser = useIsUserAuth();
  const navigate = useStickySafeNavigate();

  const { account: { stage, id }, creditSearchCompleted } = useAccountContext();

  const accessiblePages: ApplicationPageType[] = useMemo(() => [
    ApplicationPageType.CASE_DETAILS,
    ...(creditSearchCompleted ? [ApplicationPageType.PRODUCT] : []),
    ...(((isInternalUser && creditSearchCompleted) || (isExternalUser && stage !== Stages.CreditDecision)) ? [ApplicationPageType.CREDIT] : []),
    ...(((isInternalUser && creditSearchCompleted) || (isExternalUser && ![Stages.CreditDecision, Stages.Affordability].includes(stage))) ? [ApplicationPageType.TASKS] : []),
    ...((isInternalUser && creditSearchCompleted) ? [ApplicationPageType.CHECKLIST] : []),
    ...((isInternalUser && creditSearchCompleted) ? [ApplicationPageType.AUDIT] : []),
  ], [creditSearchCompleted, stage, isExternalUser, isInternalUser]);

  useEffect(() => {
    if (id === defaultGuid) return;

    const canAccessPage = accessiblePages.includes(currentPage);

    if (!canAccessPage) {
      navigate(`/application/${id}`);
    }
  }, [accessiblePages, currentPage, id]);
}
